import(/* webpackMode: "eager" */ "/vercel/path0/app/(frontend)/error.tsx");
